import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWithDefaults } from "../config/fetchDefault";

export const fetchCalendarThunk = createAsyncThunk(
    "calendarData/fetchCalendarData",
    async ({agentId}, {rejectWithValue}) => {
        try {
            const response = await fetchWithDefaults(`/google/calendars?agent=${agentId}`)
            if (!response.ok) {
                if (response.status) {
                    return rejectWithValue({needAuth: true})
                }
                return rejectWithValue({needAuth: false, error: 'Network response was not ok'})
            }
            const jsonData = await response.json();

            if(jsonData?.status === false){
                return []
            }

            return jsonData
        } catch (error) {
            return rejectWithValue(error.message)
        }
    }
)

export const calendarSlice = createSlice({
    name: "calendarData",
    initialState: {
        data: [],
        status: null,
        error: null,
        needAuth: false,
    },
    reducers:{},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCalendarThunk.pending, (state) => {
            state.status = "loading"
            state.loadable = false
        })
        .addCase(fetchCalendarThunk.fulfilled, (state, action) => {
            state.status = "succeeded"
            state.data = [...action.payload]
            state.loadable = true
        })
        .addCase(fetchCalendarThunk.rejected, (state, action) => {
            state.status = "failed";
            state.loadable = true

            state.error = action.payload.error
            state.needAuth = action.payload.needAuth
        })
    }
})

export default calendarSlice.reducer;